export const oneSecond = () => 1000;
export const oneMinute = () => 60 * oneSecond();
export const oneHour = () => 60 * oneMinute();
export const oneDay = () => 24 * oneHour();
export const oneWeek = () => 7 * oneDay();
export const getLastWeek = () => new Date(new Date().getTime() - oneWeek());
export const getNextDay = (data: Date) => new Date(data.getTime() + oneDay());
export const getToday = () => {
  const date = new Date(new Date().toISOString().slice(0, 10));
  date.setHours(0);
  date.setMinutes(0);
  date.setSeconds(0);
  date.setMilliseconds(0);
  return date;
};
